<template>
  <v-card>
    <v-card-title>
      <span class="display-1">Byt lösenord</span>
    </v-card-title>
    <v-card-actions>
        <v-icon class="close" @click="cancel">$sl-close</v-icon>
      </v-card-actions>

    <v-card-text>
      <v-form ref="form" :lazy-validation="true">
        <v-text-field
          label="Nytt lösenord"
          outlined
          v-model="password"
          type="password"
          ref="password"
          :rules="[rules.required, rules.pwdLength]"
        />
        <v-text-field
          label="Bekräfta nytt lösenord"
          v-model="passwordConfirmation"
          outlined
          type="password"
          :rules="[rules.required, rules.pwdMatch(password,passwordConfirmation)]"
        />
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-space-between">                    
      <v-btn @click="save"><v-icon>$sl-check</v-icon>Byt lösenord</v-btn>
      <v-btn color="secondary" @click="cancel"><v-icon>$sl-cancel</v-icon>Avbryt</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {RulesMixin} from '@/components/mixins'

// @group Person
export default {
  name: 'ChangePassword',

  mixins: [RulesMixin],

  data: () => ({
    password: '',
    passwordConfirmation: ''
  }),

  methods: {
    // @vuese
    // Method to change password
    save() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      // Fire when the form is submitted
      // @arg The argument is the new password to be changed
      this.$emit('save', this.password)
    },
    // @vuese
    // Method to cancel change password
    cancel() {
      // Fire when the form is canceled
      this.$emit('cancel')
    }
  }
}
</script>

<style>
</style>